import { homePageBreadcrumbs } from 'utils/breadcrumbs';

export const REGISTRY_LINK = '/registry/gmp/registry';

export const breadcrumbs = [
  homePageBreadcrumbs,
  {
    text: 'Заключения GMP',
  },
  {
    link: REGISTRY_LINK,
    text: 'Государственный реестр заключений о соответствии (GMP)',
  },
  {
    text: 'Просмотр',
  },
];
